package com.tixforgigs.common.core.util

import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.core.imports.SentryJs
import com.tixforgigs.common.http.HttpClient
import js.objects.unsafeJso
import kotlinx.browser.window

actual object SentryUtil {
  init {
    window.onerror = { message, source, lineno, colno, error ->
      error?.let {
        captureException(it as Throwable)
      } ?: run {
        captureMessage("Uncaught error: $message")
      }
      false
    }
  }

  actual fun init() {
    initSentry()
  }

  private fun initSentry() {
    SentryJs.init(
      options = unsafeJso {
        dsn = HttpClient.SENTRY_URL
        sendDefaultPii = true
        environment = HttpClient.FLAVOR.value
        release = CommonBuildKonfig.API_VERSION
        tracesSampleRate = 1.0
        autoSessionTracking = true
        beforeSend = { event: dynamic, hint: dynamic ->
          event
        }
      }
    )
    SentryJs.setTag("platform", "web")
  }

  actual fun captureException(error: Throwable) {
    SentryJs.captureException(error)
  }

  actual fun captureMessage(message: String, level: String?) {
    level?.let {
      SentryJs.captureMessage(message, it)
    } ?: run {
      SentryJs.captureMessage(message)
    }
  }
}
